import Swiper, { Navigation, Pagination, Autoplay, Thumbs, EffectFade } from 'swiper';
import 'swiper/css/bundle';
Swiper.use([Navigation, Pagination, Autoplay, Thumbs, EffectFade]);

import { setMatchHeight } from '../common/setMatchHeight';

export const setSwiper = () => {
  swiper();
  fullSwiper();
  firstviewSwiper();
  swiper4();
  // swiper3;
  // topicsSwiper;
  // plansSwiper;
};

//サイトdefault
//同一ページに複数ある場合は表示領域にあるスライダーのみ動作
const swiper = () => {
  const slider = document.querySelectorAll('.js-swiper');

  for (let i = 0; i < slider.length; i++) {
    const num = ('00' + (i + 1)).slice(-2);
    slider[i].className += num;
    const swiper = new Swiper('.js-swiper' + num, {
      spaceBetween: 30,
      effect: 'fade',
      speed: 2000,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      loop: true,
      autoplay: true,
    });

    const observerEntry = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio >= 1) {
          swiper.autoplay.start();
        } else if (entry.intersectionRatio === 0) {
          swiper.autoplay.stop();
          //常に先頭のスライドへ戻したい時用
          //mySwiperIO.slideToLoop(0);
        }
      });
    };

    //IntersectionObserverオプション
    const Options = {
      //全て見えるときと全て見えないときを検知するための閾値
      threshold: [0, 1],
      //見える手前100pxで表示する用
      //rootMargin: '100px',
    };

    //オブザーバーを生成
    const observer = new IntersectionObserver(observerEntry, Options);

    observer.observe(slider[i]);
  }
};

//full幅
const fullSwiper = () => {
  new Swiper('.js-fullSwiper', {
    spaceBetween: 15,
    speed: 1000,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    slidesPerView: 1.1,
    centeredSlides: true,
    breakpoints: {
      561: {
        slidesPerView: 1.567,
        spaceBetween: 40,
      },
    },
  });
};

export const swiper3Option = {
  modules: [Navigation, Pagination],
  spaceBetween: 40,
  speed: 1000,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  loop: true,
  slidesPerView: 1,
  breakpoints: {
    561: {
      slidesPerView: 3,
    },
  },
};
//pc3,sp1
export const swiper3 = new Swiper('.js-swiper3', swiper3Option);

setMatchHeight();

//topics
export const topicsSwiper = () => {
  new Swiper('.js-topics-swiper', {
    spaceBetween: 40,
    speed: 1000,
    navigation: {
      nextEl: '.swiper-button-next.topics',
      prevEl: '.swiper-button-prev.topics',
    },
    loop: true,
    slidesPerView: 1,
    breakpoints: {
      561: {
        slidesPerView: 3,
      },
    },
    observer: true,
    observeSlideChildren: true,
  });
};

//plans
export const plansSwiper = () => {
  new Swiper('.js-plans-swiper', {
    spaceBetween: 40,
    speed: 1000,
    navigation: {
      nextEl: '.swiper-button-next.plans',
      prevEl: '.swiper-button-prev.plans',
    },
    loop: true,
    slidesPerView: 1,
    breakpoints: {
      561: {
        slidesPerView: 3,
      },
    },
  });
};

//firstview
const firstviewSwiper = () => {
  new Swiper('.js-firstviewSwiper', {
    spaceBetween: 30,
    effect: 'fade',
    speed: 2000,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    loop: true,
  });
};

//無限
const swiper4 = () => {
  new Swiper('.js-swiper4', {
    allowTouchMove: false,
    freeMode: true,
    loop: true,
    loopedSlides: 6,
    autoplay: {
      delay: 1,
    },
    spaceBetween: 10,
    speed: 12000,
    slidesPerView: 1,
    breakpoints: {
      561: {
        slidesPerView: 3,
      },
    },
  });
};
